<template>

    <div>
        <div>
            <div class="page__head container">
                <div class="page__head-inner block">
                    <h1 class="page__title page__title--icon">
                        <div class="fab-icon">
                            <i class="icon icon--dialog"></i>
                        </div>
                        Регистрация в Едином Портале Потребителей СГК
                    </h1>
                    <div class="register-form register-form--full b-form b-form--lg">
                        <div class="page__descr page__descr--half-width-offset">
                            Добро пожаловать в обновлённый Единый Портал Потребителей! Укажите Ваш сотовый номер и e-mail адрес, подтвердив их проверочным кодом, они будут использоваться для авторизации на портале.
                        </div>
                        <div class="alert alert--error" v-if="registerError!=''">{{registerError}}</div>
                    </div>
                </div>
            </div>
            <div class="page__main container">
                <div class="page__index block">
                    <div class="register-form register-form--full b-form b-form--lg">
                        <form action="" class="js-form">
                            <div class="b-form__columns">
                                <div class="b-form__column">
                                    <div class="b-form__col b-form__col--half register-form__timer-col">
                                        <div class="js-timer-container register-form__input-inner js-valid-input-container">
                                            <div class="b-form__col">
                                                <label class="txt-input">
                                                    <div class="txt-input__label">Номер мобильного телефона *</div>
                                                    <div class="txt-input--rel">
                                                        <div class="txt-input__input">
                                                            <!--<div class="txt-input__field input" disabled v-if="isPhoneVerified==1">
                                                                {{phone}}
                                                            </div>-->
                                                            <!--<div class="alert alert--success" v-if="isPhoneVerified==1">
                                                                 {{phone}}
                                                            </div>-->
                                                            <masked-input class="txt-input__field input"
                                                                          :class="this.$v.phoneForApi.$invalid && this.phone != '' && this.phone.length>10 || phoneVerifyError != '' ? 'is-error' : ''"
                                                                          id="phone"
                                                                          type="text"
                                                                          placeholder="Введите номер телефона"
                                                                          :mask="phoneMask"
                                                                          v-model="phone" />
                                                            <div class="txt-input__required txt-input__required--error">{{phoneTypeText}}{{phoneVerifyError}}</div>
                                                        </div>
                                                        <div class="help">
                                                            <div class="help__icon help__icon--abs fab-icon" data-toggle="dropdown">
                                                                <i class="icon icon--help"></i>
                                                            </div>
                                                            <div class="help__drop">
                                                                <div class="help__inner">
                                                                    В качестве логина вы можете использовать Ваш e‑mail адрес, номер телефона или произвольный логин, указанный при регистрации на портале.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                            <div class="b-form__col b-form__col--full register-form__input-timer js-capcha-container js-code-container">
                                                <button type="button" class="button button--th-main js-capcha-show-trigger js-valid-input-disabled"
                                                        :class="this.$v.phoneForApi.$invalid ? 'is-disable' : ''">
                                                    Подтвердить номер
                                                </button>
                                                <button type="button" class="button button--th-main js-poison-code js-capcha-hidden-block" v-on:click="verifyPhoneStart" style="display: none;">Отправить проверочный код</button>
                                                <div class="register-form__row js-capcha-show-container" style="display: none;" v-if="isPhoneVerified!=1">
                                                    <div class="register-form__row-half-item  txt-input__input">
                                                        <input type="text" id="capchainput" class="txt-input__field input req js-capcha-input" placeholder="Введите код" v-model="captchacode">
                                                    </div>
                                                    <!--<div class="txt-input__required txt-input__required--error txt-input__required--dbl">{{phoneTypeText}}{{phoneVerifyError}}</div>-->
                                                    <div id="captcha1" class="register-form__row-half-item capcha-image js-capcha-image">
                                                        <img src="/Captcha/Index">
                                                    </div>
                                                    <button type="button" class="register-form__row-half-item button button--th-main js-capcha-next-trigger" v-on:click="checkCaptcha" style="display: none;">OK</button>
                                                </div>
                                                <div class="register-form__row js-connect-edm js-code-inner" style="display: none;">
                                                    <label class="txt-input register-form__row-half-item">
                                                        <input class="input js-code-input" type="text" placeholder="Введите код" v-model="phoneCode">
                                                        <div class="input__required txt-input__required--error" v-if="isPhoneVerified==-1">Код введен неверно</div>
                                                    </label>
                                                    <div class="register-form__row-half-item timer-container-sm">
                                                        <button type="button" class="button button--th-main timer-container-sm__btn js-code-submit" v-on:click="verifyPhoneCheckCode">
                                                            OK
                                                            <span class="form-timer form-timer--light js-timer">
                                                                <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                                                    <path stroke-dasharray="28" class="form-timer__circle js-timer-circle" d="
																M 50, 50
																m -45, 0
																a 45,45 0 1,0 90,0
																a 45,45 0 1,0 -90,0
																"></path>
                                                                </svg>
                                                                <span class="js-timer-count form-timer__count"></span>
                                                            </span>
                                                        </button>
                                                    </div>
                                                    <div class="register-form__row-half-item" style="display: none;">
                                                        <button type="button" class="button button--th-main js-poison-code">Отправить снова</button>
                                                    </div>
                                                </div>
                                                <button type="button" class="button button--th-main js-poison-code js-poison-code-again" style="display: none;" v-on:click="verifyPhoneStart" v-if="isPhoneVerified!=1">Отправить еще раз</button>
                                                <div class="js-success-message alert alert--sm alert--success" v-if="isPhoneVerified==1">
                                                    Номер подтвержден
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-form__col b-form__col--half register-form__timer-col">
                                        <div class="js-timer-container register-form__input-inner js-valid-input-container">
                                            <div class="b-form__col">
                                                <label class="txt-input">
                                                    <div class="txt-input__label">E-mail (не обязательно)</div>
                                                    <div class="txt-input--rel">
                                                        <div class="txt-input__input">
                                                            <!--<div class="alert alert--success" v-if="isEmailVerified==1">
                                                                {{email}}
                                                            </div>-->
                                                            <input class="txt-input__field input"
                                                                   :class="this.$v.email.$invalid && this.email != '' && this.email.length>4 || emailVerifyError != '' ? 'is-error' : ''"
                                                                   autocomplete="off"
                                                                   id="email"
                                                                   type="text"
                                                                   placeholder="Введите адрес эл.почты"
                                                                   v-model="email">
                                                            <div class="txt-input__required txt-input__required--error">{{emailTypeText}}{{emailVerifyError}}</div>
                                                        </div>
                                                        <div class="help">
                                                            <div class="help__icon help__icon--abs fab-icon" data-toggle="dropdown">
                                                                <i class="icon icon--help"></i>
                                                            </div>
                                                            <div class="help__drop">
                                                                <div class="help__inner">
                                                                    В качестве логина вы можете использовать Ваш e‑mail адрес, номер телефона или произвольный логин, указанный при регистрации на портале.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                            <div class="b-form__col b-form__col--full register-form__input-timer js-capcha-container js-code-container">
                                                <button type="button" class="button button--th-main js-capcha-show-trigger js-valid-input-disabled js-capcha-show-trigger-email"
                                                        :class="(this.$v.email.$invalid || this.email == '') ? 'is-disable' : ''" v-on:click="verifyEmailStart">
                                                    Подтвердить Email
                                                </button>
                                                <button type="button" class="button button--th-main js-poison-code js-capcha-hidden-block" style="display: none;" v-on:click="verifyEmailStart">Отправить проверочный код</button>
                                                
                                                <div class="register-form__row js-connect-edm js-code-inner js-code-inner-email" style="display: none;">
                                                    <label class="txt-input register-form__row-half-item">
                                                        <input class="input js-code-input"
                                                               :class="isEmailVerified==-1 ? 'is-error' : ''"
                                                               autocomplete="off"
                                                               type="text" placeholder="Введите код" v-model="emailCode">
                                                        <div class="txt-input__required txt-input__required--success txt-input__required--dbl" v-if="isEmailVerified==1">Код введен верно</div>
                                                        <div class="txt-input__required txt-input__required--error txt-input__required--dbl" v-if="isEmailVerified==-1">Код введен неверно</div>
                                                    </label>
                                                    <div class="register-form__row-half-item timer-container-sm">
                                                        <button type="button" class="button button--th-main timer-container-sm__btn js-code-submit" v-on:click="verifyEmailCheckCode">
                                                            OK
                                                            <span class="form-timer form-timer--light js-timer-email">
                                                                <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                                                    <path stroke-dasharray="28" class="form-timer__circle js-timer-circle" d="
																M 50, 50
																m -45, 0
																a 45,45 0 1,0 90,0
																a 45,45 0 1,0 -90,0
																"></path>
                                                                </svg>
                                                                <span class="js-timer-count form-timer__count" data-circle-timer-time>{{counter}}</span>
                                                            </span>
                                                        </button>
                                                    </div>
                                                    <div class="register-form__row-half-item" style="display: none;">
                                                        <button type="button" class="button button--th-main js-poison-code">Отправить снова</button>
                                                    </div>
                                                </div>
                                                <button type="button" class="button button--th-main js-poison-code js-poison-code-again" style="display: none;" v-on:click="verifyEmailStart">Отправить еще раз</button>
                                                <div class="js-success-message alert alert--sm alert--success" v-if="isEmailVerified==1">
                                                    Email подтвержден
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="b-form__column">
                                    <div class="b-form__col b-form__col--half">
                                        <label class="txt-input">
                                            <div class="txt-input__label">Логин *</div>
                                            <div class="txt-input--rel">
                                                <div class="txt-input__input">
                                                    <div class="txt-input__field input" disabled>
                                                        {{phoneForApi}}
                                                    </div>
                                                </div>
                                                <div class="help">
                                                    <div class="help__icon help__icon--abs fab-icon" data-toggle="dropdown">
                                                        <i class="icon icon--help"></i>
                                                    </div>
                                                    <div class="help__drop">
                                                        <div class="help__inner">
                                                            В качестве логина вы можете использовать Ваш e‑mail адрес, номер телефона или произвольный логин, указанный при регистрации на портале.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="b-form__col b-form__col--half">
                                        <label class="txt-input">
                                            <div class="txt-input__label">Как к Вам обращаться?</div>
                                            <div class="txt-input__input">
                                                <input class="txt-input__field input" type="text" v-model="firstName">
                                            </div>
                                        </label>
                                    </div>
                                    <div class="b-form__col b-form__col--half">
                                        <label class="txt-input">
                                            <div class="txt-input__label">Пароль *</div>
                                            <div class="txt-input--rel">
                                                <div class="txt-input__input">
                                                    <input class="txt-input__field input req is-filled js-psw-input"
                                                           :class="this.$v.password.$invalid && password != '' ? 'is-error' : ''"
                                                           autocomplete="off"
                                                           v-model="password"
                                                           type="password">
                                                    <div class="txt-input__ctrl">
                                                        <div class="button-icon js-show-password"><i class="icon icon--view"></i></div>
                                                    </div>
                                                    <div class="txt-input__required txt-input__required--error">{{passwordTypeText}}</div>
                                                </div>
                                                <div class="help">
                                                    <div class="help__drop js-message-drop">
                                                        <div class="help__inner">
                                                            <span>Для защиты ваших данных необходимо придумать безопасный пароль. <br>Он должен содержать:</span> <br>

                                                            <span class="error-msg"
                                                                  :class="!$v.password.minLength || password == '' ? 'error-block' : 'validated-block'">{{$v.password.$params.minLength.min}} и более символов</span>
                                                            <span class="error-msg"
                                                                  :class="!$v.password.mustOneMoreUpperCase ? 'error-block' : 'validated-block'">Прописные буквы [A-Z][А-Я]</span>
                                                            <span class="error-msg"
                                                                  :class="!$v.password.mustOneMoreLowerCase ? 'error-block' : 'validated-block'">Строчные буквы [a-z][а-я]</span>
                                                            <span class="error-msg"
                                                                  :class="!$v.password.mustOneMoreSpecialCharacter ? 'error-block' : 'validated-block'">Специальные символы [!@#$%^&*()_+.]</span>
                                                            <span class="error-msg"
                                                                  :class="!$v.password.mustOneMoreDigit ? 'error-block' : 'validated-block'">Цифры</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="b-form__col b-form__col--half">
                                        <label class="txt-input">
                                            <div class="txt-input__label">Подтверждение пароля *</div>
                                            <div class="txt-input__input">
                                                <input class="txt-input__field input req is-filled js-psw-repeat"
                                                       :class="this.$v.confirmPassword.$invalid && password != '' ? 'is-error' : ''"
                                                       autocomplete="off"
                                                       v-model="confirmPassword"
                                                       type="password">
                                                <div class="txt-input__ctrl">
                                                    <div class="button-icon js-show-password"><i class="icon icon--view"></i></div>
                                                </div>
                                                <div class="txt-input__required txt-input__required--error">{{confirmPasswordTypeText}}</div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="page__descr page__descr--full" v-if="phoneVerifyError=='Данный контакт уже используется в другом профиле. Измените телефон.'">
                                <h2>Внимание!</h2><br />
                                <strong>Этот номер телефона уже используется в системе Единого Портала Потребителей (ЕПП)</strong>. Для вашей безопасности и удобства важно иметь только один профиль, привязанный к данному номеру.<br /><br />
                                <h3>Что делать?</h3><br />
                                <p>
                                    <strong>1. Вспомните свой профиль:</strong> Попробуйте вспомнить, к какому логину привязан ваш профиль с этим номером телефона. Вы можете уточнить логин или восстановить пароль в разделе <a href='/Account/Recovery'>"Забыли логин или пароль?"</a>.<br />
                                </p><br />
                                <p>
                                    <strong>2. Войдите в существующий профиль:</strong> Используйте логин и ваш пароль <a href='' data-drop-toggle='modalLogin'>для входа в систему</a>.
                                </p><br />
                                <p>
                                    <strong>3. Объединение профилей:</strong> Если вы успешно вошли в свой профиль, система может автоматически предложить вам объединить лицевые счета из разных профилей. Подтвердите объединение, чтобы собрать все данные в одном месте.
                                </p><br />
                                <p>
                                    <strong>4. Если у вас возникли сложности:</strong><br /><br />
                                    &emsp;&emsp;&bull; Если вы не помните данные для входа, воспользуйтесь функцией в разделе <a href="/Account/Recovery">"Забыли логин или пароль?"</a>.<br /><br />
                                    &emsp;&emsp;&bull; Если данные не подтянулись автоматически, добавьте лицевые счета вручную в вашем профиле.<br /><br />
                                    &emsp;&emsp;&bull; Если вышеописанные инструкции Вам не помогли, напишите нам на почтовый адрес <a href="mailto:epp@sibgenco.ru?subject=Регистрация в ЕПП">epp@sibgenco.ru</a>.
                                </p>
                            </div><br />
                            <div class="b-form__footer b-form__footer--reqister">
                                <div class="register-submit register-submit--offset-right">
                                    <div class="register-submit__col register-submit__col--column register-submit__col--offset-right">
                                        <div class="register-submit__caption register-submit__caption-bottom register-submit__caption--full ex-small">
                                            * — обязательные поля к заполнению. Указанные данные можно изменить в разделе «Настройки личного кабинета» после успешной регистрации
                                        </div>
                                    </div>
                                    <div class="register-submit__col register-submit__col--block">
                                        <div class="register-submit__check">
                                            <div class="fast-pay-submit__line">
                                                <label class="cb-input cb-input--right">
                                                    <input class="cb-input__checkbox" type="checkbox" v-model="isAgreedRules">
                                                    <span class="cb-input__check"></span>
                                                    <span class="cb-input__label">Я принимаю <a href="/site/useragreementUR" target="_blank" class="link link--present">«Правила пользования системой»</a></span>
                                                </label>
                                            </div>
                                            <div class="fast-pay-submit__line">
                                                <label class="cb-input cb-input--right">
                                                    <input class="cb-input__checkbox" type="checkbox" v-model="isAgreedPaymentRules">
                                                    <span class="cb-input__check"></span>
                                                    <span class="cb-input__label">
                                                        С порядком и условиями оплаты, <br>
                                                        <a href="/site/useragreementUR#:~:text=5,-.%20Порядок" target="_blank" class="link link--underline"><span class="link__text">зачисления</span></a> и
                                                        <a href="/site/useragreementUR#:~:text=5,-.%20Порядок" target="_blank" class="link link--underline"><span class="link__text">возврата</span></a> денежных средств согласен.
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                        <button type="button" class="register-submit__button register-submit__button--offset-top button button--th-main"
                                                :class="(this.$v.$invalid || isPhoneVerified != 1 || !isAgreedRules || !isAgreedPaymentRules) ? 'is-disable' : ''" v-on:click="Register">
                                            Зарегистрироваться
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="b-form__message alert" data-message=""></div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

    const { required, minLength, maxLength, sameAs } = window.validators
    const { validationMixin } = window.vuelidate

    /*import Recaptcha from './Recaptcha.vue'*/
    import MaskedInput from 'vue-masked-input';

    import { formatMobileNumberToDigits } from '../../../../wwwroot/app/epp.utils';

    export default {
        mixins: [validationMixin],
        components: {
            /*'recaptcha': Recaptcha,*/
            'masked-input': MaskedInput,
        },
        //props: {
        //    sitekey: String
        //},
        data: function () {
            return {
                isServerVerify: false,
                isAgreedRules: false,
                isAgreedPaymentRules: false,
                lifeTimeRestoreCode: 300,
                counter: 100,
                login: '',
                password: '',
                confirmPassword: '',
                phone: '',
                captchacode: '',
                email: '',
                firstName: '',
                middleName: '',
                phoneMask: {
                    pattern: '\+7-w11-111-1111',
                    formatCharacters: {
                        'w': {
                            validate: function (char) { return /\9/.test(char) },
                            transform: function (char) { return char.toLowerCase() }
                        }
                    }
                },
                isValidateErrors: false,
                serverMessage: '',
                serverResponse: [],
                countCheck: 1,

                /// верификация телефона
                phoneVerifyError: '',
                isPhoneVerified: 0,
                phoneCode: '',
                /// верификация email
                emailVerifyError: '',
                isEmailVerified: 0,
                emailCode: '',
                //ошибка регистрации
                registerError: ''

            }
        },
        created() {
        },
        mounted() {
            const inputPassword = document.querySelector(".js-psw-input");
            const messageDrop = document.querySelector(".js-message-drop");
            if (inputPassword) {
                // Когда пользователь нажимает на поле пароль, появляется окно сообщения
                inputPassword.addEventListener('focus', function () {
                    if (messageDrop) messageDrop.classList.add('show');
                });
                // Когда пользователь щелкает за пределами поля пароля, скройте окно сообщения
                inputPassword.addEventListener('blur', function () {
                    if (messageDrop) messageDrop.classList.remove('show');
                });
            }

            const capchaImage = document.querySelector(".js-capcha-image");
            const capchaButton = document.querySelector(".js-capcha-next-trigger");
            if (captchacode.length === 6) {
                capchaImage.style.display = 'none';
                capchaButton.style.display = '';
            }
        },
        computed: {
            //getSendingRequest: function () {
            //    return this.sendingRequest
            //},
            passwordTypeText: function () {
				return this.$v.password.$invalid && this.password != ''  ? 'Пароль не соответствует требованиям, выделенным красным цветом выше' : '';
            },
            loginTypeText: function () {
                return !this.$v.login.loginType && this.login != '' ? 'Логин может содержать буквы [A-Z][a-z][А-Я][а-я] цифры [0-9] и спецсимволы [!@#$%^&*()_+.]' : ' ';
            },
            confirmPasswordTypeText: function () {
                return this.$v.confirmPassword.$invalid && this.password != '' ? 'Пароли должны совпадать' : '';
            },
            emailTypeText: function () {
                if (this.$v.email.$invalid && this.email != '' && this.email.length>4) {
                    this.emailVerifyError = '';
                    return 'Недопустимые символы в e-mail адресе';
                }
                return '';
            },
            phoneTypeText: function () {
                if (this.$v.phoneForApi.$invalid && this.phone != '' && this.phone.length > 10) {
                    this.phoneVerifyError = '';
                    return 'Номер должен содержать 10 цифр';
                }
                return '';
            },
            serverResponseText: function () {
                return this.serverMessage != '' ? this.serverMessage : 'Указанные данные можно изменить в разделе "Настройки личного кабинета" после успешной регистрации';
            },
            phoneForApi: function () {
                return formatMobileNumberToDigits(this.phone) ? formatMobileNumberToDigits(this.phone) : null;
            }
        },
        watch: {
            isValidateErrors: function (isValidateErrors) {
                if (!isValidateErrors) {
                    this.serverMessage = '';
                }
            },
            serverResponse: function (serverResponse) {
                if (serverResponse.isSuccess) {
                    this.isValidateErrors = false;
                    this.isServerVerify = true;
                    //this.$emit('update', this.newLogin);
                    //this.serverMessage = ['Логин успешно изменён, укажите его при следующем входе'];
                } else {
                    this.isValidateErrors = true;
                    this.isServerVerify = false;
                    this.serverMessage = serverResponse.message[0];
                }
            }
        },
        validations: {
            login: {
                required: false,
                //required: required,
                maxLength: maxLength(30),
                loginType: function (value) {
                    return true;
                    //return value.match('^[A-Za-zА-Яа-я0-9!@#$%^&*()_+.]+$') ? true : false;
                }
            },
            password: {
                required: required,
                minLength: minLength(8),
                mustOneMoreUpperCase: function (value) {
                    return value.match('[A-ZА-Я]+') ? true : false;
                },
                mustOneMoreLowerCase: function (value) {
                    return value.match('[a-zа-я]+') ? true : false;
                },
                mustOneMoreSpecialCharacter: function (value) {
                    return value.match('[!@#$%^&*()_+.]+') ? true : false;
                },
                mustOneMoreDigit: function (value) {
                    return value.match('[0-9]+') ? true : false;
                }
            },
            confirmPassword: {
                sameAsconfirmPassword: sameAs('password')
            },
            phoneForApi: {
                required: required,
                length: function (value) {
                    return this.phone != '' && this.phoneForApi == null ? false : true;
                }
            },
            email: {
                required: false,
                emailType: function (value) {
                    if (value != '') {
                        return value.match('\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*') ? true : false;
                    }
                    return true;
                }
            }
        },
        methods: {
            test: function () {
                console.log(' email=', this.email, ' isEmailVerified=', this.isEmailVerified, ' isAgreedPaymentRules=', this.isAgreedPaymentRules);
                console.log(' this.email =="" =', this.email == '', ' isEmailVerified<1 =', this.isEmailVerified < 1, ' t =', (this.email == '' && this.isEmailVerified < 1));
                //
                //(this.$v.$invalid || isPhoneVerified != 1 || !isAgreedRules || !isAgreedPaymentRules || !(this.email == '' && this.isEmailVerified < 1))
                console.log(' this.$v.$invalid =', this.$v.$invalid);
                console.log(' isPhoneVerified != 1 =', this.isPhoneVerified != 1);
                console.log(' !isAgreedRules =', !this.isAgreedRules);
                console.log(' !isAgreedPaymentRules =', !this.isAgreedPaymentRules);
                console.log(' !(this.email == "" && this.isEmailVerified < 1) =', !(this.email == '' && this.isEmailVerified < 1));
                console.log(' !(email != "" && isEmailVerified < 1) =', !(this.email != '' && this.isEmailVerified < 1));



            },
            verifyPhoneCode: async function () {
                var self = this;
                this.isValidateErrors = false;
                return await axios.post('/Register/VerifyCode', {
                    Phone: self.phoneForApi,
                    VerificationCode: self.phoneCode
                })
                    .then(function (response) {
                        if (response.data.isSuccess) {
                            self.phoneVerifyError = '';
                        }
                        else {
                            self.phoneVerifyError = response.data.message.join();
                            self.isValidateErrors = true;
                        }
                        return response.data.isSuccess;
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        return false;
                    });
            },
            verifyEmailCode: async function () {
                var self = this;
                this.isValidateErrors = false;

                return await axios.post('/Register/VerifyCode', {
                    Login: formId,
                    Email: self.email,
                    VerificationCode: self.emailCode
                })
                    .then(function (response) {
                        if (response.data.isSuccess) {
                            self.emailVerifyError = '';
                        }
                        else {
                            self.emailVerifyError = response.data.message.join();
                            self.isValidateErrors = true;
                        }
                        return response.data.isSuccess;
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        return false;
                    });
            },
            verifyEmailCheckCode: async function (event) {

                event.stopPropagation();
                this.isEmailVerified = 0;

                if (this.emailCode == '') {
                    return;
                }

                const showCapchaContainer = document.querySelector('.js-code-inner-email');
                const container = $('.js-timer-container.email');
                const poisonCode = container.find('.js-poison-code')
                const poisonCodeAgain = container.find('.js-poison-code-again');
                const connectEdm = container.find('.js-connect-edm');
                const inputCode = container.find('.js-input-code');
                const timer = container.find('.js-timer');

                showCapchaContainer.style.display = 'none';
                if (await this.verifyEmailCode()) {
                    this.isEmailVerified = 1;
                    inputCode.hide();
                }
                else {
                    //$("#phone").prop("disabled", false);
                    this.isEmailVerified = -1;
                }
            },

            verifyPhoneCheckCode: async function (event) {

                event.stopPropagation();
                this.isPhoneVerified = 0;
                const showCapchaContainer = document.querySelector('.js-code-inner');

                if (this.phoneCode == '') {
                    return;
                }

                const container = $('.js-timer-container.phone');
                const poisonCode = container.find('.js-poison-code')
                const poisonCodeAgain = container.find('.js-poison-code-again');
                const connectEdm = container.find('.js-connect-edm');
                const inputCode = container.find('.js-input-code');
                const timer = container.find('.js-timer');

                var v = await this.verifyPhoneCode();
                showCapchaContainer.style.display = 'none';

                if (v) {
                    this.isPhoneVerified = 1;
                    inputCode.hide();
                }
                else {
                    this.isPhoneVerified = -1;

                }

            },
            showCaptcha: function () {
                document.querySelector(".js-capcha-show-trigger-email").style.display = 'none';
                document.querySelector(".js-capcha-show-container-email").style.display = '';

            },
            enterCaptcha: function () {
                document.querySelector(".js-capcha-show-container").style.display = 'none';
                document.querySelector(".js-capcha-hidden-block").style.display = '';

            },
            getRandomInt: function (min, max) {
                min = Math.ceil(min);
                max = Math.floor(max);
                return Math.floor(Math.random() * (max - min) + min);
            },
            checkCaptcha: function (event) {
                event.stopPropagation();

                const self = this;

                const hiddenBlock = document.querySelector('.js-capcha-hidden-block'); // Кнопка отправить проверочный код
                const showCapchaContainer = document.querySelector('.js-capcha-show-container'); // Блок капчи
                const nextTrigger = document.querySelector('.js-capcha-next-trigger');
                const input = document.querySelector('.js-capcha-input');
                const image = document.querySelector('.js-capcha-image');
                var count = this.getRandomInt(0, 100);

                axios.post('/Register/CheckCaptcha/' + self.captchacode)
                    .then(function (response) {
                        if (response.data.isSuccess) {
                            hiddenBlock.style.display = '';
                            showCapchaContainer.style.display = 'none';
                        }
                        if (!response.data.isSuccess) {
                            var countch = self.countCheck++;
                            self.isValidateErrors = true;
                            self.isServerVerify = false;
                            $("#phone").prop('disabled', '');

                            if (countch % 2 === 0) {
                                var str = '<img src="/Captcha/Index/' + count + '">';
                                $("#captcha1").html(str);
                            }
                            nextTrigger.style.display = 'none';
                                    image.style.display = '';
                                    input.classList.add('is-error');
                        }
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.phoneVerifyError = 'Верификация телефона невозможна, попробуйте позже';
                        $("#phone").prop('disabled', '');
                    });
            },

            verifyPhoneStart: function (event) {
                event.stopPropagation();

                if (this.phoneForApi == null) {
                    return;
                }

                const self = this;

                const image = document.querySelector('.js-capcha-image');
                const okbut = document.querySelector('.js-capcha-next-trigger');
                okbut.style.display = 'none';

                var code = self.captchacode;
                self.captchacode = '';

                console.log("verifyPhoneStart");
                $("#phone").attr('disabled', 'disabled');
                self.phoneVerifyError = '';
                self.isPhoneVerified = 0;
                self.phoneCode = '';
                var tvalue = $('input[name="__RequestVerificationToken"]').val();
                let axiosConfig = {
                    headers: { 'RequestVerificationToken': tvalue }
                };
                const data = {
                };
                console.info(self.phoneForApi);

                const showCapchaTrigger = document.querySelector('.js-capcha-show-trigger');
                const showCapchaContainer = document.querySelector('.js-code-inner');

                var count = this.getRandomInt(0, 100);

                axios.post('/Register/SendRequestPhoneVerify/' + self.phoneForApi, data, axiosConfig)
                    .then(function (response) {
                        if (response.data.isSuccess) {
                            const showTimer = document.querySelectorAll('.js-timer');
                            $(showTimer).addClass('is-show');
                            const container = $('.js-timer-container.phone');
                            const poisonCode = container.find('.js-poison-code')
                            const poisonCodeAgain = container.find('.js-poison-code-again');
                            const connectEdm = container.find('.js-connect-edm');
                            const inputCode = container.find('.js-input-code');
                            const timer = container.find('.js-timer')[0];
                            console.log("Poison Code", poisonCode);
                            if (poisonCode.length > 0) {
                                poisonCode.hide();
                                poisonCodeAgain.hide();
                                if (connectEdm) connectEdm.show();
                                if (inputCode) inputCode.show();
                                playTimer(timer);
                                self.checkTimer(poisonCodeAgain, self.verifyPhoneAgain);
                            };
                        }
                        if (!response.data.isSuccess) {
                            self.isValidateErrors = true;
                            self.isServerVerify = false;
                            self.phoneVerifyError = response.data.message.join('');
                            $("#phone").prop('disabled', '');
                            var str = '<img src="/Captcha/Index/' + count + '">';
                            $("#captcha1").html(str);
                            showCapchaTrigger.style.display = '';
                            showCapchaContainer.style.display = 'none';
                            image.style.display = '';
                        }
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.phoneVerifyError = 'Верификация телефона невозможна, попробуйте позже';
                        $("#phone").prop('disabled', '');

                        var str = '<img src="/Captcha/Index/' + count + '">';
                        $("#captcha1").html(str);
                        showCapchaTrigger.style.display = '';
                        showCapchaContainer.style.display = 'none';
                        image.style.display = '';
                    });
            },
            verifyPhoneAgain() {
                $("#phone").prop('disabled', '');
            },
            verifyEmailStart: function (event) {
                if (this.email == '') {
                    return;
                }

                const self = this;

                $("#email").attr('disabled', 'disabled');
                self.emailVerifyError = '';
                self.isEmailVerified = 0;
                self.emailCode = '';

                const showCapchaTrigger = document.querySelector('.js-capcha-show-trigger-email');
                const showCodeInner = document.querySelector('.js-code-inner-email');

                showCapchaTrigger.style.display = 'none';
                showCodeInner.style.display = '';
                const showTimer = document.querySelector('.js-timer-email');
                $(showTimer).addClass('is-show');

                axios.post('/Register/SendRequestEmailVerify/' + formId + '/' + self.email)
                    .then(function (response) {
                        if (response.data.isSuccess) {
                            const container = $('.js-timer-container.email');
                            const poisonCode = container.find('.js-poison-code')
                            const poisonCodeAgain = container.find('.js-poison-code-again');
                            const connectEdm = container.find('.js-connect-edm');
                            const inputCode = container.find('.js-input-code');
                            const timer = container.find('.js-timer')[0];
                            self.counter = self.lifeTimeRestoreCode;
                            self.countdown();
                            if (poisonCode.length > 0) {

                                poisonCode.hide();
                                poisonCodeAgain.hide();
                                if (connectEdm) connectEdm.show();
                                if (inputCode) inputCode.show();
                                playTimer(timer);
                                self.checkTimer(poisonCodeAgain, self.verifyEmailAgain);
                            };
                        }
                        if (!response.data.isSuccess) {
                            self.isValidateErrors = true;
                            self.isServerVerify = false;
                            self.emailVerifyError = response.data.message.join('');
                            $("#email").prop('disabled', '');
                            showCapchaTrigger.style.display = '';
                            showCodeInner.style.display = 'none';

                            //axios.get('/Captcha/Index')
                            //    .then(function (response) {
                            //        showCapchaTrigger.style.display = '';
                            //        showCapchaContainer.style.display = 'none';
                            //    })
                        }

                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.emailVerifyError = 'Верификация email невозможна, попробуйте позже';
                        $("#email").prop('disabled', '');
                    });

                event.stopPropagation();
            },
            verifyEmailAgain() {
                $("#email").prop('disabled', '');
            },

            checkTimer(timer, fn) {
                var timerInterval = null;
                timerInterval = setInterval(function () {
                    if (timer.css('display') != 'none') {
                        fn();
                        clearInterval(timerInterval);
                    }
                }, 2000);
            },

            countdown: function () {
                var self = this;
                setTimeout(function () {
                    self.counter--;
                    self.countdown();

                },
                    1000);
            },

			IsSiriusAccountUnionComplete: function () {
				var self = this;

				axios.post('/Account/IsSiriusAccountUnionComplete')
					.then(function (response) {
						window.location.href = response.data;
					})
					.catch(function (error) {
					});
			},

            Register: function () {
                var self = this;
                this.isValidateErrors = false;
                self.login = self.phoneForApi;
                axios.post('/Register/RegisterAsync', {
                    Login: self.login,
                    Password: self.password,
                    ConfirmPassword: self.confirmPassword,
                    User: {
                        PhoneNumber: self.phoneForApi,
                        Email: self.email != '' && self.isEmailVerified ? self.email : '',
                        FirstName: self.firstName,
                    },
                    IsAgreeRules: self.isAgreedRules
                })
                    .then(function (response) {
                        if (response.data.isSuccess) {
							self.IsSiriusAccountUnionComplete();
                           // window.location.href = "/register/RegisterFork";
                        }
                        self.registerError = response.data.errors.join("\n");
                        self.isPhoneVerified = 0;
                        self.isEmailVerified = 0;
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.serverMessage = ['Регистрация невозможна, попробуйте позже']
                    });
            },
        }
    }

</script>
<style>
    .error-block {
        display: block;
        color: #ef3e55;
    }

    .validated-block {
        display: block;
        color: #0078a8;
        opacity: 1;
    }

    .show {
        display: block;
    }

    .hide {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// Scripts/app/register/components/Register.vue